// Never use raw string interpolation for returnTo — the & in multi-param
// returnTo values will be parsed as separate top-level params otherwise.

/**
 * buildReturnToUrl("/login", "/mcp-connect?a=1&b=2")
 * → "/login?returnTo=%2Fmcp-connect%3Fa%3D1%26b%3D2"
 */
export function buildReturnToUrl(basePath: string, returnTo: string): string {
  const params = new URLSearchParams({ returnTo });
  return `${basePath}?${params.toString()}`;
}

export function getCurrentRelativeUrl(location: {
  pathname: string;
  search: string;
}): string {
  return location.search
    ? `${location.pathname}${location.search}`
    : location.pathname;
}
